import axios from '../request/http';

const Login = {
    // 获取验证码
    getCode() {
        return axios.get("/admin/captcha");
    },
    // 登录
    login(params) {
        return axios.get("/admin/login", {params});
    },
    // 获取角色列表
    adminJurisdiction(params) {
        return axios.get("/admin/roles/list", {params});
    },
    // 获取管理台信息
    getManageInfo(params) {
        return axios.get("/admin/roles/info", {params});
    },
    // 获取统计数据
    userNumber(params) {
        return axios.get("/admin/homeInfo/statistics", {params});
    },
    getGeneralView(params) {
        return axios.get("/admin/homeInfo/generalView", {params});
    },

}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js